import { MAX_WEIGHT } from '../weightToIndex';

const indexToWeight = (index: number) => {
  const weight = index * 100;

  return MAX_WEIGHT - weight;
};

export default indexToWeight;
